import type { IconSvgObject } from './types';

const BathIcon: IconSvgObject = [
  ["path", { d: "M20 11H4C3.44772 11 3 11.4477 3 12V13C3 16.3137 5.68629 19 9 19H15C18.3137 19 21 16.3137 21 13V12C21 11.4477 20.5523 11 20 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 11V5.12132C5 3.94975 5.94975 3 7.12132 3C7.68393 3 8.2235 3.2235 8.62132 3.62132L10 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 6L11 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 19L6 21M17 19L18 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default BathIcon;
